export type BlMountChannel = {
	trigger: (event: 'react.mount' | 'react.unmount') => void;
};

declare global {
	interface Window {
		$?: (element: Element) => BlMountChannel;
	}
}

export function registerBlPlaceholder(element: Element | null): void {
	element?.dispatchEvent(new CustomEvent('react.register', { bubbles: true }));
}

export function mountBlPlaceholder(element: Element | null): void {
	if (element) {
		window.$?.(element)?.trigger('react.mount');
	}
}

export function unmountBlPlaceholder(element: Element | null): void {
	if (element) {
		window.$?.(element)?.trigger('react.unmount');
	}
}
